// Import model
import { StartLeadSendRememberMeSmsRequest } from '../models/StartLeadSendRememberMeSmsRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartLeadSendRememberMeSmsRequest - handles JSON serialization and deserialization with type validation
 */
export class StartLeadSendRememberMeSmsRequestSerializer {
  /**
   * Deserializes a JSON string into a StartLeadSendRememberMeSmsRequest instance
   */
  static deserialize(json: string): StartLeadSendRememberMeSmsRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartLeadSendRememberMeSmsRequest instance
   */
  static fromObject(obj: any): StartLeadSendRememberMeSmsRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartLeadSendRememberMeSmsRequest');
    }


    const instance: StartLeadSendRememberMeSmsRequest = {
      phoneNumber: obj['PhoneNumber'] as string | undefined,
      description: obj['Description'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartLeadSendRememberMeSmsRequest instances
   */
  static deserializeArray(json: string): StartLeadSendRememberMeSmsRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartLeadSendRememberMeSmsRequest instance to a JSON string
   */
  static serialize(instance: StartLeadSendRememberMeSmsRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartLeadSendRememberMeSmsRequest instance to a plain object
   */
  static toObject(instance: StartLeadSendRememberMeSmsRequest): any {
    return {
      'PhoneNumber': instance.phoneNumber,
      'Description': instance.description,
    };
  }

  /**
   * Serializes an array of StartLeadSendRememberMeSmsRequest instances to a JSON string
   */
  static serializeArray(instances: StartLeadSendRememberMeSmsRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
